import { FormikProps } from 'formik';

export declare class ErrorItem {
  code: string;
  description: string;
}

export declare class ValidationErrorMap {
  [fieldName: string]: ErrorItem[];
}

export interface VssApiErrorMeta {
  validationErrors?: ValidationErrorMap;
  errors?: ErrorItem[];
}

export class VssApiError {
  code?: string;
  message: string;
  meta?: VssApiErrorMeta;
  status: number;
}

export type FormikPropsWithServerError = {
  server?: string;
};

export type FormFieldNameMap = {
  [fieldName: string]: string;
};

export class FormValidationHelper {
  static populateErrorsFromResponse(
    form: FormikProps<FormikPropsWithServerError>,
    error: VssApiError,
    fieldNameMap?: FormFieldNameMap
  ) {
    FormValidationHelper.populateServerErrors(form, error.meta, fieldNameMap);
  }

  static populateServerErrors(
    form: FormikProps<FormikPropsWithServerError>,
    serverErrors: VssApiErrorMeta,
    fieldNameMap: FormFieldNameMap = null
  ) {
    if (serverErrors) {
      if (
        serverErrors.validationErrors &&
        Object.keys(serverErrors.validationErrors).length > 0
      ) {
        const formErrors = {};
        for (const key in serverErrors.validationErrors) {
          if (serverErrors.validationErrors[key]) {
            const element: ErrorItem[] = serverErrors.validationErrors[key];
            if (element?.length > 0) {
              const fieldKey =
                fieldNameMap && key in fieldNameMap ? fieldNameMap[key] : key;
              const fieldMeta = form.getFieldMeta(fieldKey);
              if (fieldMeta) {
                form.setFieldTouched(fieldKey, true, false);
                const keys = fieldKey.split('.');
                let current = formErrors;
                for (let i = 0; i < keys.length - 1; i++) {
                  if (!current[keys[i]]) {
                    current[keys[i]] = {};
                  }
                  current = current[keys[i]];
                }
                current[keys[keys.length - 1]] = element[0].description;
              }
            }
          }
        }
        setTimeout(() => {
          form.setErrors(formErrors);
        }, 1);
      } else if (
        serverErrors.errors &&
        Array.isArray(serverErrors.errors) &&
        serverErrors.errors.length > 0
      ) {
        form.setErrors({ server: serverErrors.errors[0].description });
      } else {
        form.setErrors({
          server: 'Our server dropped the ball. Try again.'
        });
      }
    }

    return form;
  }
}
